import { createPortal } from 'react-dom';
import { LogOut, Loader2, X } from 'lucide-react';

interface MdtLogoutConfirmModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void | Promise<void>;
  loggingOut?: boolean;
}

export default function MdtLogoutConfirmModal({
  open,
  onClose,
  onConfirm,
  loggingOut = false,
}: MdtLogoutConfirmModalProps) {
  if (!open) return null;

  return createPortal(
    <div
      className="fixed inset-0 z-[600] flex items-end justify-center sm:items-center p-4"
      style={{ background: 'rgba(0,0,0,0.75)' }}
    >
      <div
        className="w-full max-w-sm rounded-2xl p-5 space-y-4"
        style={{ background: '#1a1d23', border: '1px solid rgba(255,255,255,0.08)' }}
      >
        <div className="flex items-start justify-between gap-3">
          <div className="flex items-center gap-3">
            <div
              className="w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0"
              style={{ background: 'rgba(255,80,116,0.12)', border: '1px solid rgba(255,80,116,0.2)' }}
            >
              <LogOut className="w-5 h-5 text-red-400" />
            </div>
            <div>
              <p className="text-[15px] font-extrabold text-white">Sign out of MDT?</p>
              <p className="text-[11px] text-white/40 mt-0.5">Confirm before leaving the mobile terminal</p>
            </div>
          </div>
          <button
            type="button"
            onClick={onClose}
            disabled={loggingOut}
            className="p-1 rounded-lg hover:bg-white/[0.06] transition-colors disabled:opacity-40"
          >
            <X className="w-4 h-4 text-white/40" />
          </button>
        </div>

        <p className="text-xs text-white/60 leading-relaxed">
          You will be released from your unit, location tracking will stop, and any active assignment will be cleared from this device.
        </p>

        <div className="flex flex-col gap-2 pt-1">
          <button
            type="button"
            disabled={loggingOut}
            onClick={() => void onConfirm()}
            className="w-full py-3 rounded-xl text-sm font-bold transition-all active:scale-[0.98] flex items-center justify-center gap-2 disabled:opacity-60"
            style={{ background: 'rgba(239,68,68,0.18)', border: '1px solid rgba(239,68,68,0.35)', color: '#f87171' }}
          >
            {loggingOut ? <Loader2 className="w-4 h-4 animate-spin" /> : <LogOut className="w-4 h-4" />}
            {loggingOut ? 'Signing out…' : 'Sign out'}
          </button>
          <button
            type="button"
            disabled={loggingOut}
            onClick={onClose}
            className="w-full py-2.5 rounded-xl text-xs font-semibold text-white/50 hover:text-white/70 transition-colors disabled:opacity-40"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>,
    document.body,
  );
}
